import styled from "styled-components";

export const DeviceSectionContainer = styled.div`
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;

  padding: 60px 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 130px;
  box-sizing: border-box;
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.8s ease, transform 0.8s ease;

  @media (max-width: 1920px) {
    gap: 100px;
  }

  @media (max-width: 1200px) {
    gap: 80px;
  }

  @media (max-width: 992px) {
    gap: 60px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 40px 20px;
    gap: 40px;
    position: relative;
    min-height: 500px;
  }

  &.visible {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const DeviceTextContainer = styled.div`
  flex: 1;
  max-width: 35%;
  opacity: 0;
  transform: translateX(-20px);
  transition: opacity 0.8s ease, transform 0.8s ease;
  transition-delay: 0.2s;

  @media (max-width: 1200px) {
    max-width: 40%;
  }

  @media (max-width: 992px) {
    max-width: 45%;
  }

  @media (max-width: 768px) {
    max-width: 100%;
    width: 100%;
    position: relative;
    z-index: 2;
    transform: translateY(20px);

    .visible & {
      transform: translateY(0);
    }
  }

  .visible & {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const DeviceTitle = styled.h2`
  font-size: 56px;
  font-weight: 700;
  font-family: "Pretendard";
  line-height: 1.4;
  margin-bottom: 20px;
  white-space: pre-line;

  @media (max-width: 1920px) {
    font-size: 48px;
    line-height: 1.4;
    margin-bottom: 20px;
  }

  @media (max-width: 1440px) {
    font-size: 36px;
    line-height: 1.35;
    margin-bottom: 18px;
  }

  @media (max-width: 1024px) {
    font-size: 32px;
    line-height: 1.25;
    margin-bottom: 14px;
  }

  @media (max-width: 768px) {
    font-size: 28px;
    line-height: 1.2;
    text-align: left;
    word-break: keep-all;
  }

  @media (max-width: 480px) {
    font-size: 24px;
    line-height: 1.15;
  }
`;

export const DeviceDescription = styled.p`
  font-size: 32px;
  font-weight: 600;
  color: #666;
  white-space: pre-line;
  line-height: 1.5;

  @media (max-width: 1920px) {
    font-size: 24px;
    line-height: 1.5;
    margin-bottom: 18px;
  }

  @media (max-width: 1440px) {
    font-size: 20px;
    line-height: 1.45;
    margin-bottom: 16px;
  }

  @media (max-width: 1024px) {
    font-size: 18px;
    line-height: 1.35;
    margin-bottom: 14px;
  }

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 1.3;
    margin-bottom: 12px;
    padding: 0 20px;
    word-break: keep-all;
  }

  @media (max-width: 480px) {
    font-size: 14px;
    line-height: 1.25;
    margin-bottom: 10px;
    padding: 0 10px;
  }
`;

export const DeviceImage = styled.img`
  max-width: 65%;
  height: auto;
  opacity: 0;
  transform: translateX(20px);
  transition: opacity 0.8s ease, transform 0.8s ease;
  transition-delay: 0.4s;

  @media (max-width: 1200px) {
    max-width: 60%;
  }

  @media (max-width: 992px) {
    max-width: 70%;
  }

  @media (max-width: 768px) {
    max-width: 70%;
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 1;
    opacity: 0.8;
    transform: translateY(20px);

    .visible & {
      transform: translateY(0);
    }
  }

  @media (max-width: 480px) {
    max-width: 70%;
  }

  .visible & {
    opacity: 1;
    transform: translateX(0);
  }
`;
